<template>
  <div id="app" :class="SelectClass()">
    <router-view/>
  </div>
</template>

<script>
import Global from "@/components/Global";
import { isMobile } from "mobile-device-detect";
export default {
  name: "App",
  props: ["staff","accessToken"],
  created() {
    this.Init();
  },
  methods: {
    Init: function() {
       Global.widget_staff = this.staff;
       Global.widget_accesstoken = this.accessToken;       
      // if (this.widget != "" && this.widget != undefined) {
      //   this.$router.push({ name: this.widget });
      // }
    },
    SelectClass() {
      if (isMobile) {
        return "appBefore";
      } else {
        return "nothing";
      }
    },
  }
};
</script>

<style>
/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue